import {useEffect, useState} from 'react'
import {homeListCategoryTree} from '../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useIntl} from 'react-intl'
import {Navigate, Route, Routes, useLocation} from 'react-router-dom'
import {PageLink, PageTitle} from '../../_metronic/layout/core'
import Tray from '../pages/Tray'
import SelectTrayContent from '../pages/SelectTrayContent'
import {Error404} from '../modules/errors/components/Error404'

function TrayRoutes() {
  const [menuCategoryTray, setMenuCategoryTray] = useState<any>([])
  const [contentPaths, setContentPaths] = useState<string[]>([])
  const [categoryPaths, setCategoryPaths] = useState<string[]>([])

  const intl = useIntl()

  const getList = async () => {
    try {
      const {data} = await homeListCategoryTree(true, 0, 0, '', 'en', '', '')
      setMenuCategoryTray(data[1].subList)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      setMenuCategoryTray([])
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  useEffect(() => {
    if (menuCategoryTray.length) {
      const allContentPaths: string[] = []
      const allCateogyrPaths: string[] = []
      menuCategoryTray.forEach((category: any) => {
        const contentPaths = generateContentPaths(category)
        allContentPaths.push(...contentPaths)
        const categoryPaths = generateCategoryPaths(category)
        allCateogyrPaths.push(...categoryPaths)
      })
      setContentPaths(allContentPaths)
      setCategoryPaths(allCateogyrPaths)
    }
  }, [menuCategoryTray])

  function generateCategoryPaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const id = node.id
      const parentId = node.parentId
      const path = `${prefix}/${node.nodeAd.toLowerCase('TR').replace(/\s/g, '-')}`
      paths.push({id, parentId, path})
    }
    traverse(data)
    return paths
  }

  function generateContentPaths(data: any) {
    const paths: any = []

    function traverse(node: any, prefix = '') {
      const id = node.id
      const parentId = node.parentId
      const path = `${prefix}/${node.nodeAd.toLowerCase('TR').replace(/\s/g, '-')}`

      if (node.subList) {
        node.subList.forEach((subNode: any) => {
          traverse(subNode, path)
        })
      } else {
        paths.push({id, parentId, path})
      }
    }

    traverse(data)
    return paths
  }

  const {pathname} = useLocation()
  const [trayIndex, setTrayIndex] = useState(1)

  useEffect(() => {
    const startIndex = pathname.indexOf('tray-')
    const endIndex = startIndex !== -1 ? pathname.indexOf('/', startIndex) : undefined

    const result =
      startIndex !== -1 && endIndex !== -1
        ? pathname.substring(startIndex, endIndex)
        : startIndex !== -1
        ? pathname.substring(startIndex)
        : null
    setTrayIndex(Number(result?.substring(0 + 5)))
  }, [pathname])

  return (
    <Routes>
      <Route index element={<Navigate to={`tray-${trayIndex}`} />} />
      {Array.from(new Set(categoryPaths)).map((item: any, index: number) => {
        const selecCategoryBreadCrumbs: Array<PageLink> = [
          {
            title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '/tray' + item.path,
            isSeparator: true,
            isActive: false,
          },
        ]
        return (
          <Route
            key={index}
            path={`${item.path}`}
            element={
              <>
                <PageTitle breadcrumbs={selecCategoryBreadCrumbs}>
                  {intl.formatMessage({id: 'SLIDEMENU.TRAY'})}
                </PageTitle>
                {/*}
                <Tray id={Number(item.id)} parentId={item.parentId} />
            {*/}
                <Tray />
              </>
            }
          />
        )
      })}
      {contentPaths.map((item: any, index: number) => {
        const selecExperimentDetailBreadCrumbs: Array<PageLink> = [
          {
            title: intl.formatMessage({id: 'SLIDEMENU.HOME'}),
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
          {
            title: 'Trays',
            path: '/trays',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '/trays' + item?.path,
            isSeparator: true,
            isActive: false,
          },
        ]
        return (
          <Route
            key={index}
            path={`${item?.path}`}
            element={
              <>
                <PageTitle breadcrumbs={selecExperimentDetailBreadCrumbs}>
                  {intl.formatMessage({id: 'SLIDEMENU.TRAYCONTENT'})}
                </PageTitle>
                <SelectTrayContent id={item?.id} parentId={item.parentId} />
              </>
            }
          />
        )
      })}
    </Routes>
  )
}

export default TrayRoutes
